var APP_DOMAIN = 'app';
var SET_BACK_OVERRIDE = 'set_back_override';
export var reset = function () { return ({
    domain: 'app',
    eventType: 'reset',
    data: {},
}); };
export var openFile = function (path) { return ({
    domain: APP_DOMAIN,
    eventType: 'open_file',
    data: {
        path: path,
    }
}); };
export var setAuthenticationStatus = function (isAuthenticated) { return ({
    domain: 'app',
    eventType: 'set_authentication_status',
    data: {
        is_authenticated: isAuthenticated,
    },
}); };
export var setBackOverride = function (enabled) { return ({
    domain: APP_DOMAIN,
    eventType: SET_BACK_OVERRIDE,
    data: {
        is_enabled: enabled,
    },
}); };
//# sourceMappingURL=app.js.map